import * as React from 'react';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { AppBar, Box, Toolbar, IconButton, Typography, MenuItem, Menu } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import logo from '../../assets/images/ctslogo.svg';
import { Slide, Link } from '@mui/material';
import useTimeout from '../shared/customhooks/use-timeout';
import { useAppSelector, useAppDispatch } from '../stores/hooks'
import { menuopen, menuclose } from '../stores/menuslice';
import { useNavigate } from 'react-router-dom';
import { openDialog } from '../stores/updatepasswordslice';
import { notFromLogin } from '../stores/envsettingdialogslice';
import { msalInstance } from '../..';

export default function Header() {

  const isMenuOpen = useAppSelector((state) => state.menuReducer.isMenuOpen);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [showFullName, setShowFullName] = React.useState<boolean>(true);
  const [userFullName, setUserFullName] = React.useState<string>('');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [tocName, setTocName] = React.useState<string | null>(null);
  const selectedToc = useAppSelector((state) => state.settingsReducer.Toc);
  const selectedEnv = useAppSelector((state) => state.settingsReducer.Environment);
  const isProfileMenuOpen = Boolean(anchorEl);


  React.useEffect(() => {
    setTocName(selectedToc?.Description ?? null);
  }, [selectedToc])

  React.useEffect(() => {

    const account = msalInstance.getAllAccounts()[0];
    msalInstance.setActiveAccount(account);
    setUserFullName(account.name ?? account.username);

    // if(authService.IsTokenValid()){
    //   let currentUser=authService.getCurrentUser();
    //   // updateDefaultToc(currentUser);
    //   setUserFullName(currentUser.FullName);
    //   if(currentUser.TocId!='-99')
    //     setTocName(currentUser.Toc);
    //   else
    //     updateDefaultToc(currentUser);
    //   dispatch(updateauthentocated(true));
    //   if( currentUser.LastLoginDate == null || currentUser.LastLoginDate == ""){
    //     dispatch(openDialog());
    //     dispatch(disableCancelButton());
    //     dispatch(isFromLogin());
    //   }
    //   else if(currentUser.TocId=='-99')
    //   {
    //     dispatch(openEnvSettingDialog());

    //   }

    // }
    // else{
    //   instance.loginRedirect(loginRequest).catch((e) => {
    //     console.log(e);
    //   });
    //   // let locationSplit=window.location.href.split('/');
    //   // sessionStorage.setItem('redirecturl','/'+locationSplit[locationSplit.length-1])
    //   // navigate('/login');
    // }
  }, []);

  useTimeout(() => {
    setShowFullName(false);
  }, 5000)

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  // const updateDefaultToc = (user: User) => {
  //   if (user.TocId > 0) return;
  //   let toc = null;
  //   let tocfromStorage = localStorage.getItem('Toc');
  //   if (tocfromStorage) {
  //     toc = JSON.parse(tocfromStorage);
  //   }
  //   let defaultToc = process.env.REACT_APP_DEFAULT_TOC;
  //   if (!toc) {
  //     localStorage.setItem('Toc', defaultToc ?? "");
  //   }
  // }

  // const updateDefaultToc = () => {
  //   //if (user.TocId > 0) return;
  //   let toc = null;
  //   let tocfromStorage = localStorage.getItem('Toc');
  //   if (tocfromStorage) {
  //     toc = JSON.parse(tocfromStorage);
  //   }
  //   let defaultToc = process.env.REACT_APP_DEFAULT_TOC;
  //   if (!toc) {
  //     localStorage.setItem('Toc', defaultToc ?? "");
  //   }
  // }

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    msalInstance.logoutRedirect();
    //authService.logout(redirectToLogin);
  }


  const redirectToLogin = () => {
    navigate('/login');
  }



  const onMouseEnterName = () => {
    setShowFullName(true);
  };

  const onMouseLeavName = () => {
    setShowFullName(false);
  };

  const handlePasswordChange = () => {
    dispatch(openDialog())
    dispatch(notFromLogin());
  }

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{ mt: 6 }}
      open={isProfileMenuOpen}
      onClose={handleMenuClose}
    >
      {/* <MenuItem sx={{minWidth:'150px'}} onClick={handleMenuClose}>Profile</MenuItem> */}
      {/* <MenuItem sx={{ minWidth: '150px' }} onClick={handlePasswordChange}>Change Password</MenuItem> */}
      <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
    </Menu>
  );



  return (
    <Box>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', flex: 1 }}>
            <Box>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="open drawer"
                sx={{ mr: 1,mt:-2.5 }}
                onClick={() => dispatch(isMenuOpen ? menuclose() : menuopen())}
              >
                <MenuIcon />
              </IconButton>
              <Link href="/">
                <Box
                  component="img"
                  sx={{ height: 30, mt: 1 }}
                  alt="Logo"
                  src={logo}
                />
              </Link>
            </Box>
            <Box sx={{display:'flex',justifyContent:'space-around',mt:1}}>
              
              <Box component="div" onMouseEnter={onMouseEnterName} onMouseLeave={onMouseLeavName}>
                <Typography variant='h5' sx={{ display: 'inline-flex' }}>T</Typography>
                <Slide in={showFullName} appear={!showFullName} direction="down" timeout={500} >
                  <Typography variant='body1' sx={{ display: { md: showFullName ? 'inline-flex' : 'none', xs: 'none' } }}>icket</Typography>
                </Slide>
                <Typography variant='h5' sx={{ display: 'inline-flex', ml: { xs: 0, md: 1 } }}>R</Typography>
                <Slide in={showFullName} appear={!showFullName} direction="down" timeout={500} >
                  <Typography variant='body1' sx={{ display: { md: showFullName ? 'inline-flex' : 'none', xs: 'none' } }}>epository &</Typography>
                </Slide>
                <Typography variant='h5' sx={{ display: 'inline-flex', ml: { xs: 0, md: 1 } }}>A</Typography>
                <Slide in={showFullName} appear={!showFullName} direction="down" timeout={500} >
                  <Typography variant='body1' sx={{ display: { md: showFullName ? 'inline-flex' : 'none', xs: 'none' } }}>nalytics</Typography>
                </Slide>
                <Typography variant='h5' sx={{ display: 'inline-flex', ml: { xs: 0, md: 1 } }}>C</Typography>
                <Slide in={showFullName} appear={!showFullName} direction="down" timeout={500} >
                  <Typography variant='body1' sx={{ display: { md: showFullName ? 'inline-flex' : 'none', xs: 'none' } }}>ontrol</Typography>
                </Slide>
                <Typography variant='h5' sx={{ display: 'inline-flex', ml: { xs: 0, md: 1 } }}>S</Typography>
                <Slide in={showFullName} appear={!showFullName} direction="down" timeout={500} >
                  <Typography variant='body1' sx={{ display: { md: showFullName ? 'inline-flex' : 'none', xs: 'none' } }}>ystem</Typography>
                </Slide>
              </Box>
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{ ml: 1, display: { xs: 'none', sm: 'block' } }}
              >
                {tocName ? "(" + tocName + " - " + process.env.REACT_APP_ENV + ")" : ""}
              </Typography>
            </Box>
            {/* <Box sx={{ flexGrow: 1 }} /> */}
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle />
                <Typography variant='body1'>
                  {userFullName}
                </Typography>
              </IconButton>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMenu}
    </Box>
  );
}